module.exports = __webpack_public_path__ + "img/tempture.d54fd04b.gif";